import { styled } from '@mui/material';
import type { StorageUnit } from 'store/storageunits/types';

import { useRef } from 'react';
import { useContextMenu } from '../../contextMenu/context';
import { useSelection } from '../../context';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

type Props = {
  unit: StorageUnit;
  disabled?: boolean;
};

const Button = styled('div')`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[200]};
    transition: all 400ms ease-out;
  }
`;

const MoreButton = ({ unit, disabled = false }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { openContextMenu } = useContextMenu();
  const { selectedIds } = useSelection();

  const onMoreClicked = (e: React.MouseEvent) => {
    if (disabled) {
      e.stopPropagation();
      return;
    }

    e.stopPropagation();

    if (ref.current) {
      const { top, left } = ref.current.getBoundingClientRect();
      openContextMenu(unit, { x: left, y: top });
    }
  };

  return (
    <Button
      ref={ref}
      onClick={(e) => onMoreClicked(e)}
      data-disabled={disabled ? 'true' : undefined}
      style={{
        visibility: disabled || selectedIds.length > 0 ? 'hidden' : 'visible',
      }}
    >
      <MoreVertOutlinedIcon fontSize='small' />
    </Button>
  );
};

export default MoreButton;
